<template>
    <section>
        <!--工具条-->
        <el-col v-if="buttonList != null && buttonList.length > 0" :span="24" style="padding-bottom: 0px;">
            <el-form :inline="true" :model="search">
                <el-form-item label="小程序路径">
                    <el-input v-model="search.path" placeholder="请输入小程序路径"></el-input>
                </el-form-item>
                <el-form-item v-for="item in buttonList" v-bind:key="item.id">
                    <el-button
                        :type="item.Func && (item.Func.toLowerCase().indexOf('handledel') != -1 || item.Func.toLowerCase().indexOf('stop') != -1) ? 'danger' : 'primary'"
                        v-if="!item.IsHide && (item.Func=='Add'|| item.Func== 'query')" @click="callFunc(item)">{{
                        item.name }}</el-button>
                </el-form-item>
            </el-form>
        </el-col>

        <el-col :span="24">
            <!--列表-->
            <el-table :data="data" v-loading="listLoading" row-key="Id" border style="width: 100%" ref="table" class="custom-tbl">
                <el-table-column type="index" width="80" label="序号"></el-table-column>
                <el-table-column prop="Path" label="小程序路径" width="200"></el-table-column>
                <el-table-column prop="Type" label="类型" width="120">
                    <template slot-scope="scope">
                        <el-tag type='info' disable-transitions>{{scope.row.Type==1 ? "产品详情图" : (scope.row.Type==2 ? "邀请函" : "其他") }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="EnvVersion" label="小程序版本" width="120">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.EnvVersion == 'release' ? 'success' : (scope.row.EnvVersion == 'trial' ? 'warning' : 'info')" disable-transitions>{{
                            scope.row.EnvVersion == 'release' ? '正式版' : (scope.row.EnvVersion == 'trial' ? '体验版' : '开发版')
                        }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="Width" label="宽度(px)" width="100"></el-table-column>
                <el-table-column prop="AutoColor" label="自动线条颜色" width="120">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.AutoColor ? 'success' : 'info'" disable-transitions>{{
                            scope.row.AutoColor ? "是" : "否" }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="LineColor" label="线条颜色" width="150"></el-table-column>
                <el-table-column prop="IsHyaline" label="透明底色" width="100">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.IsHyaline ? 'success' : 'info'" disable-transitions>{{
                            scope.row.IsHyaline ? "是" : "否" }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="CreateBy" label="创建用户" width="120"></el-table-column>
                <el-table-column prop="CreateTimeString" label="创建时间" width="160"></el-table-column>
                <el-table-column prop="ModifyTimeString" label="最后修改时间" width="160"></el-table-column>
                <el-table-column label="操作" width="150" fixed="right">
                    <template scope="scope">
                        <el-button size="small" type="primary"
                            v-if="buttonList != null && buttonList.filter(s => s.IsHide == false && s.Func.indexOf('update') != -1).length > 0"
                            @click="update(scope.row)">编辑</el-button>
                        <el-button type="danger" size="small"
                            v-if="buttonList != null && buttonList.filter(s => s.IsHide == false && s.Func.indexOf('handledel') != -1).length > 0"
                            @click="handledel(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>

        </el-col>
        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <el-pagination layout="total, sizes,prev, pager, next" @current-change="handleCurrentChange"
                @size-change="handleSizeChange" :current-page.sync="page" :page-size="intPageSize" :total="total"
                style="float: right"></el-pagination>
        </el-col>

        <!--修改界面-->
        <el-dialog title="二维码配置" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false">
            <el-form :model="editForm" label-width="120px" :rules="editFormRules" ref="editForm">
                <el-form-item label="小程序路径" prop="Path">
                    <el-input v-model="editForm.Path" placeholder="请输入小程序路径，如 pages/product/product"></el-input>
                </el-form-item>
                <el-form-item label="类型" prop="Type">
                    <el-radio-group v-model="editForm.Type">
                        <el-radio :label="1">产品详情图</el-radio>
                        <el-radio :label="2">邀请函</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="小程序版本" prop="EnvVersion">
                    <el-radio-group v-model="editForm.EnvVersion">
                        <el-radio label="develop">开发版</el-radio>
                        <el-radio label="trial">体验版</el-radio>
                        <el-radio label="release">正式版</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="二维码宽度" prop="Width">
                    <el-input v-model="editForm.Width" placeholder="默认430，最小280，最大1280"></el-input>
                </el-form-item>
                <el-form-item label="自动线条颜色" prop="AutoColor">
                    <el-radio-group v-model="editForm.AutoColor">
                        <el-radio :label="true">是</el-radio>
                        <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="线条颜色" prop="LineColor">
                    <el-input v-model="editForm.LineColor" placeholder='{"r":0,"g":0,"b":0}'></el-input>
                </el-form-item>
                <el-form-item label="透明底色" prop="IsHyaline">
                    <el-radio-group v-model="editForm.IsHyaline">
                        <el-radio :label="true">是</el-radio>
                        <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
            </div>
        </el-dialog>
    </section>
</template>

<script>
    import {getButtonList} from "../../../promissionRouter";
    import {getWeChatQRCodeManagePageList,removeWeChatQRCodeManage,PostWeChatQRCodeManage} from '../../../api/api';

    export default {
        data() {
            return {
                buttonList:[],
                search: { path: "" },
                total: 0,
                page: 1,
                intPageSize:30,
                listLoading: false,
                data:[],

                //修改
                editFormVisible:false,
                editLoading:false,
                editForm:{
                    Id: 0,
                    Path:'',
                    Type:1,
                    EnvVersion:'develop',
                    Width:'430',
                    AutoColor:false,
                    LineColor:'{"r":0,"g":0,"b":0}',
                    IsHyaline:false
                },
                editFormRules: {
                    Path: [{ required: true, message: "请输入小程序路径", trigger: "blur" }],
                    Type: [{ required: true, message: "请选择类型", trigger: "blur" }],
                    EnvVersion: [{ required: true, message: "请选择小程序版本", trigger: "blur" }]
                },
                IsAdd:true
            }
        },
        methods: {
            callFunc(item) {
                 this[item.Func].apply(this, item);
            },

            getWeChatQRCodeManagePageList() {
                 this.listLoading=true;
                let para = {
                    path: this.search.path,
                    page: this.page,
                    intPageSize:this.intPageSize,
                }
                getWeChatQRCodeManagePageList(para).then((res) => {
                    this.total= res.data.response.dataCount;
                    this.data = res.data.response.data?res.data.response.data:[];
                    this.listLoading=false;
                })
            },
            handleCurrentChange(val) {
                this.page = val;
                this.getWeChatQRCodeManagePageList();
            },
            handleSizeChange(val){
               this.intPageSize = val;
               this.getWeChatQRCodeManagePageList();
            },
            //查询
            query()
            {
               this.page = 1;
               this.getWeChatQRCodeManagePageList();
            },
            //删除
            handledel(row)
            {
                 this.$confirm("确认删除该二维码配置吗？", "提示", {}).then(() => {
                    let para = {
                      id: row.Id,
                    };
                    this.listLoading = true;
                    removeWeChatQRCodeManage(para)
                    .then((res) => {
                        this.listLoading = false;
                        if (res.data.success) {
                        this.$message({
                            message: res.data.msg,
                            type: "success",
                        });
                        this.getWeChatQRCodeManagePageList();
                        } else {
                        this.$message({
                            message: "删除失败！",
                            type: "error",
                        });
                        }
                    })
                    .catch(() => {
                        this.listLoading = false;
                    });
                });
            },
            //新增
            Add()
            {
                this.editForm = {
                    Id: 0,
                    Path:'',
                    Type:1,
                    EnvVersion:'develop',
                    Width:'430',
                    AutoColor:false,
                    LineColor:'{"r":0,"g":0,"b":0}',
                    IsHyaline:false
                };
                this.IsAdd = true;
                this.editFormVisible=true;
            },
            //编辑
            update(row){
                this.editForm = Object.assign({}, row);
                this.IsAdd = false;
                this.editFormVisible=true;
            },
            editSubmit(){
                this.$refs.editForm.validate((valid)=>{
                    if(valid)
                    {
                        this.$confirm("确认提交吗？", "提示", {}).then(() => {
                            this.editLoading = true;
                            let para = Object.assign({}, this.editForm);
                            PostWeChatQRCodeManage(para).then((res)=>{
                                this.editLoading = false;
                                if(res.data.success)
                                {
                                    this.$message({
                                    message: res.data.msg,
                                    type: "success",
                                    });
                                    this.editFormVisible=false;
                                    this.getWeChatQRCodeManagePageList();
                                }else {
                                    this.$message({
                                        message: res.data.msg,
                                        type: "error",
                                    });
                                }
                            })
                        });
                    }else{
                        return true;
                    }
                })
            }
        },
        mounted() {
              let routers = window.localStorage.router
            ? JSON.parse(window.localStorage.router)
            : [];
            this.buttonList = getButtonList(this.$route.path, routers);
            this.getWeChatQRCodeManagePageList();
        }
    }
</script>

<style>
    .toolbar {
        padding: 10px;
    }
</style>
